module.exports = __webpack_public_path__ + "img/normal.2c50d8e7.png";